import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ApproveForm from '../../Framework/Components/Form/ApproveForm';
import BlockStyledEditor from '../../Framework/Components/Form/BlockStyledEditor';
import Number from '../../Framework/Components/Form/Number';
import StaticDropDown from '../../Framework/Components/Form/StaticDropDown';
import TextInput from '../../Framework/Components/Form/TextInput';
import Grid, { GridLeft, GridRight } from '../../Framework/Layouts/Grid';
import StaticAutoComplete from '../../Framework/Components/Form/StaticAutoComplete';
import GoToProductChangeRequestButton from './GoToProductChangeRequestButton';
import IngredientToAliasConverter from '../../Utils/Ingredient/IngredientToAliasConverter';

const IngredientChangeRequestForm = (props) => {
    const { service } = props;
    const [categories, setCategories] = useState();

    useEffect(() => {
        service.get('ingredients/get-categories').then((result) => {
            setCategories(
                result.map((item) => ({
                    id: item.id ?? item,
                    name: item.name,
                })),
            );
        });
    }, []);

    return (
        <>
            <ApproveForm creates="ingredients" {...props}>
                <Grid>
                    <GridLeft>
                        <TextInput name="name" />
                        <BlockStyledEditor name="description" />
                        <StaticAutoComplete
                            name="categories"
                            items={categories}
                            isMultiple
                        />
                        <IngredientToAliasConverter
                            service={service}
                            resource="ingredient-change-requests"
                        />
                    </GridLeft>
                    <GridRight>
                        <StaticDropDown
                            path="ingredients/get-ewg-data-types"
                            name="ewg_data"
                        />
                        <Number name="ewg_score" min="0" max="10" />
                        <Number name="ewg_score_max" min="0" max="10" />
                        <Number name="comedogen_index" min="0" max="5" />
                        <GoToProductChangeRequestButton />
                    </GridRight>
                </Grid>
            </ApproveForm>
        </>
    );
};

export default IngredientChangeRequestForm;

IngredientChangeRequestForm.propTypes = {
    /**
     * Type of service
     */
    service: PropTypes.object.isRequired,
};
